export const usePlatformTopPaddingModifier = () => {
  return 0;
};
